import { isInstructor, isPlatformDirector } from "./roles";

/**
 * @param {{ _id?: string } | string | null | undefined} author
 * @returns {string}
 */
function resolveAuthorId(author) {
  if (author == null) {
    return "";
  }
  if (typeof author === "string") {
    return author;
  }
  if (typeof author === "object" && author._id != null) {
    return String(author._id);
  }
  return "";
}

/**
 * Instructors only see their own drafts; directors see every staff announcement.
 *
 * @param {Array<{ status?: string, author?: { _id?: string } | string | null }>} announcements
 * @param {{ userId?: string, rol?: string }} session
 * @returns {Array<{ status?: string, author?: { _id?: string } | string | null }>}
 */
export function filterStaffAnnouncements(announcements, session) {
  if (!Array.isArray(announcements)) {
    return [];
  }
  const rol = session?.rol;
  if (isPlatformDirector(rol)) {
    return announcements;
  }
  if (!isInstructor(rol)) {
    return announcements.filter((item) => item.status !== "draft");
  }
  const userId = String(session?.userId ?? "");
  return announcements.filter((item) => {
    if (item.status !== "draft") {
      return true;
    }
    return userId !== "" && resolveAuthorId(item.author) === userId;
  });
}
